<img 
    *ngIf="logoType == 'logo'"
    [ngStyle]="{'height': height}"
    class="img-fluid" 
    src="assets/images/logo/CompuBrain.svg" 
    alt="logo"
/>
<img 
    *ngIf="logoType == 'fold'"
    style="height: 33px;"
    class="img-fluid" 
    src="assets/images/logo/compuBrainMonogram.png" 
    alt="logo"
/>